import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsIosFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";
import countryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import AppIosDownloadEngagementFilter from "../../components/filters/AppDownloadEngagementFilter/ios/AppIosDownloadAndEngagementFilter";
import AppIosDownloadEngagementFilterResult from "../../components/filters/AppDownloadEngagementFilter/ios/AppIosDownloadAndEngagementFilterResult";

import FindIosDownloadAndEngagementFilter from "./IosDownloadAndEngagementFilter";

const createIosDownloadAndEngagementFilter = (
    description: FindAppsDescriptionDto,
): IFilterInstance<IAppsIosFiltersDto> => {
    const countries = countryService.getCountriesByIds([
        ...description.androidDownloadsAndEngagement.supportedCountries,
    ]);
    return {
        key: "downloadsAndEngagement",
        trackingName: "App Downloads and Engagement",
        title: { key: "si.find_apps.filters.ios-download-and-engagement.title" },
        tooltipText: { key: "si.find_apps.filters.ios-download-and-engagement.tooltip" },
        filter: new FindIosDownloadAndEngagementFilter({
            options: description.iosDownloadsAndEngagement,
            initialDtoValue: {
                country: WORLDWIDE_COUNTRY_ID,
            },
            countries: countries,
        }),
        filterView: AppIosDownloadEngagementFilter,
        filterResultView: AppIosDownloadEngagementFilterResult,
    };
};

export default createIosDownloadAndEngagementFilter;
